import Http from '@/plugins/http.js';

export default {
    getTreeNode(appItemCode) {
        return Http.GET('/api/list/GetTreeNode/' + appItemCode);
    },
    getTreeNodes(parameters) {
        return Http.POST('/api/list/GetTreeNodes', parameters);
    },
    getAppItemView(funcItemCode) {
        return Http.GET(`api/app/GetAppItemView/${funcItemCode}`);
    },
    getListHeader(appItemCode) {
        return Http.GET(`/api/list/GetListHeader/${appItemCode}`);
    },
    getListData(parameters) {
        return Http.POST('/api/list/GetListData', parameters);
    },
    getBizListData(parameters) {
        return Http.POST('/api/list/GetBizListData', parameters);
    },
    getTreeList(listParams) {
        return Http.POST('/api/list/GetTreeList', listParams);
    },
    getListHighFilter(appItemCode) {
        return Http.GET(`api/List/GetListHighFilter/` + appItemCode);
    },
    getAppItemInfo(appItemCode) {
        return Http.GET(`api/App/GetAppItemInfo/${appItemCode}`);
    },
    /**
     * 获取用户文件列表组织机构有权限部门ID
     * @param {*} appItemCode
     * @param {*} deptId
     */
    getFolderScopeIds(appItemCode, deptId) {
        return Http.GET(`api/Form/GetFolderScopeIds/${appItemCode}/${deptId}`);
    },
    /**
     * 当前目录用户是否有权限
     * @param {*} appItemCode
     * @param {*} unitId
     */
    isPermissionFolder(appItemCode, unitId) {
        return Http.GET(`api/Form/IsPermissionFolder/${appItemCode}/${unitId}`);
    },
    /**
     * 加载应用菜单数据源
     * @param {*} dataUrl 数据源地址
     * @param {*} params  查询条件
     */
    getListDataByCondition(dataUrl, params = null) {
        if (params && params.SelfSearchCondition && params.SelfSearchCondition.QueryType) {
            params.SelfSearchCondition.QueryType =
                params.SelfSearchCondition.QueryType === 'Or' ? 1 : 0;
        }
        if (!params) {
            return Http.GET(dataUrl);
        }
        return Http.POST(dataUrl, params);
    },
    //列表删除
    deleteListData(formCode, ids) {
        return Http.POST(`/api/list/DeleteListData/${formCode}`, ids);
    },
    getFunctionImportTemplete() {
        return Http.POST(`/api/App/ExportTemplateExcel`, null, 'blob');
    },
    // 主表导入
    getFileImportTemplete(appItemCode, postParam) {
        return Http.POST(`/api/List/ExportTemplateExcel/${appItemCode}`, postParam, 'blob');
    },
    //获取导入的子表模版excel文件
    getFileImportSubTableTemplate(formCode, subCode, flowId, parentDataId, fileName, postParam) {
        return Http.POST(
            `/api/List/ExportSubTableTemplate/${formCode}/${subCode}/${fileName}/${parentDataId}/${flowId}`,
            postParam,
            'blob'
        );
    },
    importFunctionData(file, data) {
        return Http.HttpFileUpload(`api/App/ImportFunctionData/`, file, data);
    },
    // 主表-新增导入-校验导入文件数据
    uploadImportData(appItemCode, saveData, file) {
        return Http.HttpFileUpload(`api/List/GetFileImportData/${appItemCode}/${saveData}`, file);
    },
    // 主表-更新导入-校验导入文件数据
    getMainImportData(appItemCode, saveData, file) {
        return Http.HttpFileUpload(`api/List/GetMainImportData/${appItemCode}/${saveData}`, file);
    },
    //子表-新增导入-校验导入子表文件
    uploadImportChildListData(formCode, subCode, flowId, parentDataId, saveData, file, formdatas) {
        return Http.HttpFileUpload(
            `api/List/GetSubTableImportData/${formCode}/${subCode}/${parentDataId}/${saveData}/${flowId}`,
            file,
            formdatas
        );
    },
    // 子表-更新导入-校验导出的可编辑的子表数据
    uploadImportEditedSubData(formCode, subCode, flowId, parentDataId, saveData, file, formdatas) {
        return Http.HttpFileUpload(
            `api/List/GetEditedImportedSubData/${formCode}/${subCode}/${parentDataId}/${saveData}/${flowId}`,
            file,
            formdatas
        );
    },
    // 主表-更新导入-上传待办
    uploadUnfinishWorkItems(appItemCode, saveData, file) {
        return Http.HttpFileUpload(
            `api/List/GetUnfinishImportData/${appItemCode}/${saveData}`,
            file
        );
    },
    // 子表-新增导入
    saveImportChildListData(formCode, subCode, flowId, parentDataId, subLayoutType, data) {
        return Http.POST(
            `api/List/ValidateSubTableData/${formCode}/${subCode}/${parentDataId}/${flowId}`,
            data
        );
    },
    saveEditedChildListData(formCode, subCode, flowId, parentDataId, data) {
        return Http.POST(
            `api/List/RelImportEditedSubData/${formCode}/${subCode}/${parentDataId}/${flowId}`,
            data
        );
    },
    // 下载具有编辑权限的子表数据
    exportEditedSubData(formCode, subCode, flowId, parentDataId, postParam) {
        return Http.POST(
            `api/List/ExportSubTableData/${formCode}/${subCode}/${parentDataId}/${flowId}`,
            postParam,
            'blob'
        );
    },
    //保存子表关联数据
    saveRelSubData(formCode, subCode, parentDataId, flowId, data) {
        return Http.POST(
            `api/List/SaveRelSubData/${formCode}/${subCode}/${parentDataId}/${flowId || ''}`,
            data
        );
    },
    InvokeMethod(formCode, methodName, bizObjectIds) {
        return Http.POST(`api/List/InvokeMethod/${formCode}/${methodName}`, bizObjectIds);
    },
    exportUnfinishWorkItems(appItemCode, postParam) {
        return Http.POST(`api/List/ExportUnfinishWorkItems/${appItemCode}`, postParam, 'blob');
    },
    // 主表更新导入，下载excel
    exportMainDataItems(appItemCode, postParam) {
        return Http.POST(`api/List/ExportDataItems/${appItemCode}`, postParam, 'blob');
    },
    // 导出主表
    exportList(exportParam) {
        return Http.POST(`api/list/ExportList`, exportParam, 'blob');
    },
    // 导出子表
    exportSubList(exportParam) {
        return Http.POST(`api/list/ExportSubList`, exportParam, 'blob');
    },
    // 二维码打印
    printQrCode(params) {
        return Http.POST(`api/list/PrintQrCode`, params, 'blob');
    },
    // blob下载
    doBlobDownload(blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        } else {
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            if (fileName && fileName.length > 0) {
                a.download = fileName;
            }
            a.click();
            window.URL.revokeObjectURL(url);
        }
    },

    saveImportData(appItemCode, data) {
        return Http.POST(`api/List/UploadImportData/${appItemCode}`, data);
    },

    saveUnfinishImportData(appItemCode, data) {
        return Http.POST(`api/List/UploadUnfinishImportData/${appItemCode}`, data);
    },

    uploadMainImportData(appItemCode, data) {
        return Http.POST(`api/List/UploadMainImportData/${appItemCode}`, data);
    },

    //保存个人列设置信息
    saveListCustomSetting(param) {
        return Http.POST(`api/List/SaveListCustomSetting`, param);
    },
    //获取个人列设置信息
    getListCustomSetting(itemCode) {
        return Http.GET(`api/List/GetListCustomSetting/${itemCode}`);
    },
    getCustomSetting(parameters) {
        return Http.POST(`api/System/GetCustomSettings`, parameters);
    },
    updateCustomSetting(setting) {
        return Http.POST(`api/System/UpdateCustomSetting`, setting);
    },
    deleteCustomSetting(ids = []) {
        return Http.POST(`api/System/DeteleCustomSetting`, ids);
    },
};
